import { Pipe, PipeTransform } from '@angular/core';
import { ContactGrouping, ContactSort, ContactType } from '@app/contacts/models/contact';
import { AppTranslateService } from '@app/core/services/app-translate.service';

@Pipe({
  standalone: true,
  name: 'contactTypeLabel',
})
export class ContactTypeLabelPipe implements PipeTransform {
  constructor(private appTranslateService: AppTranslateService) {}

  transform(value: ContactType): string {
    switch (value) {
      case ContactType.Personal: {
        return this.appTranslateService.instant('CONTACTS.MY_CONTACTS');
      }
      case ContactType.Company: {
        return this.appTranslateService.instant('CONTACTS.COMPANY_LABEL');
      }
      case ContactType.Shared: {
        return this.appTranslateService.instant('CONTACTS.SHARED_LABEL');
      }
      case ContactType.All: {
        return this.appTranslateService.instant('CONTACTS.ALL_CONTACTS');
      }
      case ContactType.Microsoft: {
        return 'Microsoft';
      }
    }
  }
}

@Pipe({
  standalone: true,
  name: 'contactSortLabel',
})
export class ContactSortLabelPipe implements PipeTransform {
  constructor(private appTranslateService: AppTranslateService) {}

  transform(value: ContactSort): string {
    switch (value) {
      case ContactSort.FirstName: {
        return this.appTranslateService.instant('CONTACTS.FIRST_NAME_LABEL');
      }
      case ContactSort.LastName: {
        return this.appTranslateService.instant('CONTACTS.LAST_NAME_LABEL');
      }
    }
  }
}

@Pipe({
  standalone: true,
  name: 'contactGroupingLabel',
})
export class ContactGroupingLabelPipe implements PipeTransform {
  constructor(private appTranslateService: AppTranslateService) {}

  transform(value: ContactGrouping): string {
    switch (value) {
      case ContactGrouping.Name: {
        return this.appTranslateService.instant('CONTACTS.NAME_LABEL');
      }
      case ContactGrouping.Site: {
        return this.appTranslateService.instant('CONTACTS.SITE_LABEL');
      }
      case ContactGrouping.Company: {
        return this.appTranslateService.instant('CONTACTS.COMPANY_LABEL');
      }
      case ContactGrouping.Department: {
        return this.appTranslateService.instant('CONTACTS.DEPARTMENT_LABEL');
      }
      default: {
        return '';
      }
    }
  }
}
